import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";

export interface Swatch {
  swatchId: string;
  status?: string;
  type?: string;
  swatchImageLg?: { url: string };
  swatchGroupName?: string;
  index?: number;
  swatchHexCode?: string;
}

export interface Finish {
  swatchId?: string;
  status?: string;
  type?: string;
  swatchImageLg?: { url: string };
  swatchGroupName?: string;
  swatchType?: string;
  swatchHexCode?: string;
}

export const selectedSwatchAtom = atom<Swatch>();
export const selectedFinishAtom = atom<Finish>();
export const useSelectedSwatchAtom = () => useAtom(selectedSwatchAtom);
export const useSelectedFinishAtom = () => useAtom(selectedFinishAtom);
export const useSetSelectedSwatchAtom = () => useSetAtom(selectedSwatchAtom);
export const useSetSelectedFinishAtom = () => useSetAtom(selectedFinishAtom);
export const useSelectedSwatchAtomValue = () =>
  useAtomValue(selectedSwatchAtom);
export const useSelectedFinishAtomValue = () =>
  useAtomValue(selectedFinishAtom);

export const selectedIndexInCarousel = atom<number>(0);
export const useSelectedSwatchIndexInCarousel = () =>
  useAtom(selectedIndexInCarousel);
export const useSelectedSwatchIndexInCarouselValue = () =>
  useAtomValue(selectedIndexInCarousel);
export const useSetSelectedSwatchIndexInCarousel = () =>
  useSetAtom(selectedIndexInCarousel);

export const isColorizedHomeImage = atom<boolean>(true);
export const useIsColorizedHomeImage = () => useAtom(isColorizedHomeImage);
export const useIsColorizedHomeImageValue = () =>
  useAtomValue(isColorizedHomeImage);
export const useSetIsColorizedHomeImage = () =>
  useSetAtom(isColorizedHomeImage);
